export default "__VITE_ASSET__YP11StdC__"